import { useEffect, useState } from 'react';

const isEditableTarget = (target) => {
  if (!target) return false;
  const tag = target.tagName?.toLowerCase();
  return (
    tag === 'input' ||
    tag === 'textarea' ||
    target.isContentEditable
  );
};

const useKeyboardShortcuts = ({
  onEscape,
  onDelete,
  onDuplicate,
  onCopy,
  onPaste,
  onBringForward,
  onSendBackward,
  onBringToFront,
  onSendToBack,
  onEnter,
}) => {
  const [isSpacePressed, setIsSpacePressed] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isEditableTarget(event.target)) {
        return;
      }

      if (event.code === 'Space') {
        event.preventDefault();
        setIsSpacePressed(true);
        return;
      }

      if (event.key === 'Escape' && onEscape) {
        onEscape();
      }

      if (event.key === 'Enter' && onEnter) {
        onEnter();
      }

      if ((event.key === 'Backspace' || event.key === 'Delete') && onDelete) {
        event.preventDefault();
        onDelete();
      }

      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'd' && onDuplicate) {
        event.preventDefault();
        onDuplicate();
      }

      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'c' && onCopy) {
        event.preventDefault();
        onCopy();
      }

      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'v' && onPaste) {
        event.preventDefault();
        onPaste();
      }

      if ((event.metaKey || event.ctrlKey) && event.key === ']' && onBringForward) {
        event.preventDefault();
        if (event.shiftKey && onBringToFront) {
          onBringToFront();
          return;
        }
        onBringForward();
      }

      if ((event.metaKey || event.ctrlKey) && event.key === '[' && onSendBackward) {
        event.preventDefault();
        if (event.shiftKey && onSendToBack) {
          onSendToBack();
          return;
        }
        onSendBackward();
      }
    };

    const handleKeyUp = (event) => {
      if (event.code === 'Space') {
        setIsSpacePressed(false);
      }
    };

    const handleBlur = () => setIsSpacePressed(false);

    window.addEventListener('keydown', handleKeyDown, { passive: false });
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleBlur);
    };
  }, [
    onBringForward,
    onBringToFront,
    onCopy,
    onDelete,
    onDuplicate,
    onEnter,
    onEscape,
    onPaste,
    onSendBackward,
    onSendToBack,
  ]);

  return { isSpacePressed };
};

export default useKeyboardShortcuts;
